<script lang="ts" setup>
import { YandexSmartCaptcha } from '@gladesinger/vue3-yandex-smartcaptcha';

const { yandexCaptchaClientKey } = useRuntimeConfig().public;

const yaCaptcha = ref<any>(null);
const token = defineModel<string>();

function execute() {
  yaCaptcha.value?.execute();
}

function reset() {
  token.value = '';
  yaCaptcha.value?.reset();
}

async function onCaptchaSuccess(spravka: string) {
  token.value = spravka;
}

function onCaptchaExpired() {
  console.log('yandex captcha token expired');
  reset();
  execute();
}

defineExpose({ execute, reset });
</script>

<template>
  <ClientOnly>
    <YandexSmartCaptcha
      ref="yaCaptcha"
      :siteKey="yandexCaptchaClientKey"
      class="absolute w-0 h-0"
      hideShield
      invisible
      shieldPosition="bottom-right"
      @onSuccess="onCaptchaSuccess"
      @onTokenExpired="onCaptchaExpired"
    />
  </ClientOnly>
</template>
